// Firebase instance injection for @3dera/core.
// Each app (web, mobile) initializes Firebase with its own persistence
// (browserLocalPersistence on web, AsyncStorage-backed on React Native)
// and calls initCore() once at startup. All services then read from the
// live bindings below.

export let app = null;
export let auth = null;
export let db = null;
export let storage = null;
export let functions = null;

// Optional env bag for secrets that differ per platform (analytics, 3rd-party keys).
// Services should read secrets via `getEnv('KEY')` instead of `import.meta.env`.
let envBag = {};

export function initCore(instances) {
  app = instances.app || null;
  auth = instances.auth || null;
  db = instances.db || null;
  storage = instances.storage || null;
  functions = instances.functions || null;
  envBag = instances.env || {};
}

export function getEnv(key) {
  return envBag[key];
}
